import { matchSorter } from "match-sorter";
import { Select } from "@icg360/ui-toolkit";
import PropTypes from "prop-types";
import React, { useState } from "react";

export const SortedSelect = ({ options = [], onInputChange, ...props }) => {
  const [inputValue, setInputValueState] = useState("");
  const matchOptions = matchSorter(options, inputValue, { keys: ["label"] });
  return (
    <Select
      {...props}
      options={inputValue ? matchOptions : options} // Avoids re-ordering options from the product when there is no user input
      onInputChange={inputValue => {
        if (typeof onInputChange === "function") {
          onInputChange();
        }
        setInputValueState(inputValue);
      }}
    />
  );
};

SortedSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  onInputChange: PropTypes.func,
  props: PropTypes.object
};
